import React from "react";
import { MapPin, Clock, Award, Star } from "lucide-react";
import { restaurant, similarRestaurants, tags } from "../mock";

export const LocationSection = () => (
  <section id="localisation" className="py-8 border-b border-gray-100">
    <h2 className="text-2xl font-bold text-gray-900 mb-4">Localisation</h2>
    <div className="rounded-2xl overflow-hidden border border-gray-200 h-72 relative">
      <iframe
        title="Localisation BAAN MAE"
        src="https://www.openstreetmap.org/export/embed.html?bbox=2.1349%2C48.8607%2C2.1449%2C48.8667&layer=mapnik&marker=48.8637304%2C2.1399103"
        className="w-full h-full"
        loading="lazy"
      />
      <a
        href="https://www.openstreetmap.org/?mlat=48.8637304&mlon=2.1399103#map=18/48.8637304/2.1399103"
        target="_blank"
        rel="noopener noreferrer"
        className="absolute bottom-3 right-3 bg-white text-xs font-semibold text-gray-700 px-3 py-1.5 rounded-full shadow-md hover:shadow-lg transition-shadow"
      >
        Voir en plein écran ↗
      </a>
    </div>
    <div className="flex items-start gap-2 mt-4 text-sm text-gray-700">
      <MapPin className="h-4 w-4 text-[#1B7B71] mt-0.5" />
      <span>{restaurant.address}</span>
    </div>
  </section>
);

export const AwardsSection = () => (
  <section className="py-8 border-b border-gray-100">
    <h2 className="text-2xl font-bold text-gray-900 mb-4">Récompenses et certifications</h2>
    <div className="flex items-center gap-3 p-4 rounded-xl bg-gradient-to-r from-[#FFF7E8] to-white border border-[#F5D4B8]">
      <div className="bg-white p-2 rounded-full shadow-sm">
        <Award className="h-6 w-6 text-[#D4A03E]" />
      </div>
      <div>
        <div className="font-semibold text-gray-900">Meilleur Hôte</div>
        <div className="text-sm text-gray-600">Récompensé pour son excellent service</div>
      </div>
    </div>
  </section>
);

export const HoursSection = () => (
  <section className="py-8 border-b border-gray-100">
    <h2 className="text-2xl font-bold text-gray-900 mb-4">Plus de détails</h2>
    <h3 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
      <Clock className="h-4 w-4 text-[#1B7B71]" /> Horaires d'ouverture
    </h3>
    <div className="divide-y divide-gray-100 max-w-md">
      {restaurant.hours.map((h) => (
        <div key={h.day} className="flex items-center justify-between py-2.5 text-sm">
          <span className="text-gray-700">{h.day}</span>
          <span className="text-gray-900 font-medium">{h.time}</span>
        </div>
      ))}
    </div>

    <h3 className="font-semibold text-gray-900 mt-6 mb-3">Caractéristiques et services</h3>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm text-gray-700">
      {restaurant.amenities.map((a) => (
        <div key={a} className="flex items-center gap-2 py-1">
          <span className="w-1.5 h-1.5 rounded-full bg-[#1B7B71]" /> {a}
        </div>
      ))}
    </div>

    <div className="mt-4 text-sm text-gray-700">
      <div><span className="font-semibold">Langues parlées :</span> {restaurant.languages.join(", ")}</div>
      <div className="mt-1"><span className="font-semibold">Paiements acceptés :</span> {restaurant.paymentMethods.join(", ")}</div>
    </div>
  </section>
);

export const SimilarRestaurants = () => (
  <section className="py-10">
    <h2 className="text-2xl font-bold text-gray-900 mb-5">Tout près du restaurant « BAAN MAE »</h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {similarRestaurants.map((r, i) => (
        <a key={i} href="#" className="group block rounded-xl overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow bg-white">
          <div className="relative aspect-[4/3] overflow-hidden bg-gray-100">
            <img src={r.img} alt={r.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            {r.badge && (
              <span className="absolute top-3 left-3 bg-white text-xs font-bold px-2 py-1 rounded-md shadow-sm text-[#1B7B71]">{r.badge}</span>
            )}
            {r.discount && (
              <span className="absolute top-3 right-3 bg-[#D14318] text-white text-xs font-bold px-2 py-1 rounded-md">Jusqu'à -{r.discount} %</span>
            )}
          </div>
          <div className="p-4">
            <div className="flex items-center justify-between gap-2 mb-1">
              <div className="font-semibold text-gray-900 truncate">{r.name}</div>
              <div className="flex items-center gap-1 text-sm font-bold text-[#1B7B71]">
                <Star className="h-3.5 w-3.5 fill-[#1B7B71]" /> {r.rating}
              </div>
            </div>
            <div className="text-xs text-gray-500">{r.city}</div>
            <div className="text-xs text-gray-700 mt-1">{r.cuisine} · ~{r.price} €</div>
          </div>
        </a>
      ))}
    </div>

    <div className="mt-10 flex flex-wrap gap-2">
      {tags.map((t) => (
        <a key={t} href="#" className="text-xs px-3 py-1.5 rounded-full border border-gray-200 text-gray-700 hover:border-[#1B7B71] hover:text-[#1B7B71] transition-colors">
          {t}
        </a>
      ))}
    </div>
  </section>
);
